<div class="row">
  <div class="col-md-12">
    <mat-card appearance="outlined" class="marB16">
      <div *ngIf="editactivity">
        <button mat-icon-button class="close-button" [mat-dialog-close]="true">
          <mat-icon class="close-icon" color="warn">close</mat-icon>
        </button>
      </div>
      <div class="d-flex justify-content-between" style="margin-left: 18px; margin-top: 18px">
        <div class="txt_left">
          <h4 class="h3Header GreyDarkest text-1line marB16">{{ checkInterviewSchDataObj.activityName }}</h4>
        </div>
        <div class="d-flex" style="margin-right: 18px">
          <span class="data-letters float-left marR6 listleft">{{ loginUserName || 'NA' | initials }}</span>
          <h5 class="marginicon40 h5Header GreyLight marT8 float-right marR16">{{ loginUserName }}</h5>
          <span class="float-right marT4">
            <span class="marginicon40 mainBodyTxt3 GreyLight blockInfo" *ngIf="timeModifiedOn; else elseTemplate">
              {{ timeModifiedOn | dateTransform }}
            </span>
            <ng-template class="mainBodyTxt3 GreyLight blockInfo" #elseTemplate> </ng-template>
          </span>
        </div>
      </div>

      <mat-card-content class="clearfix" *ngIf="isCollapsed" [ngClass]="{ readActivityDisable: data && data.readflag }">
        <form name="schedueleIntForm" #f1="ngForm">
          <div *ngIf="this.testformValid(!f1.invalid)"></div>
          <mat-form-field class="custom-form-field">
            <mat-label>Template</mat-label>
            <mat-select
              (selectionChange)="getTemplateData($event)"
              name="coupledselectedTemplate"
              [(value)]="inputVal"
              required
              [(ngModel)]="selectedTemplate"
            >
              <mat-option
                *ngFor="let template of templateData"
                [value]="template.clauseid"
                class="custom-select-option"
              >
                {{ template.clauseDescription }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <div class="row">
            <div class="col-md-2">
              <mat-form-field>
                <input
                  matInput
                  required
                  [matDatepicker]="picker"
                  name="coupledstartDate"
                  [(ngModel)]="startDate"
                  placeholder="Appointment"
                  (dateChange)="addEvent1($event)"
                />
                <mat-icon matSuffix>
                  <img
                    src="assets/images/icons/purple_icons/icon-calendar.png"
                    (click)="picker.open()"
                    alt="icon-calendar"
                  />
                </mat-icon>
                <mat-datepicker #picker touchUi></mat-datepicker>
              </mat-form-field>
            </div>
            <div class="col-md-2 offset-md-1">
              <mat-form-field>
                <input
                  matInput
                  placeholder="Time"
                  required
                  name="coupledstartTime"
                  [(ngModel)]="startTime"
                  aria-label="startTime"
                  [ngxTimepicker]="timepicker"
                  [format]="24"
                  (ngModelChange)="select(startTime)"
                  readonly
                />
                <ngx-material-timepicker #timepicker></ngx-material-timepicker>
              </mat-form-field>
            </div>
          </div>

          <mat-form-field class="custom-form-field">
            <mat-label>Venue</mat-label>
            <mat-select required name="coupledvenue" [(ngModel)]="selectedVenue">
              <mat-option *ngFor="let place of venue" [value]="place" class="custom-select-option">
                {{ place.venueName }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-checkbox
            class="custom-checkbox"
            aria-label="checkbox"
            disableRipple="true"
            name="coupledMailCheck"
            [(ngModel)]="sendMailCheck"
            (change)="sendMailEnable()"
            >Send email communication to candidate</mat-checkbox
          >

          <mat-form-field class="custom-form-field">
            <input
              matInput
              placeholder="Remarks"
              name="couplednotes"
              [(ngModel)]="notes"
              (input)="inputValRemarks = $event.target.value"
            />
          </mat-form-field>
          <div *ngIf="sendMailCheck">
            <activity-correspondence
              [ifCoupled]="ifCoupled"
              [interviewFlag]="interviewFlag"
              [selectedTemplate]="selectedTemplate"
              [selectedClauseIndex]="selectedClauseIndex"
              [InterviewTemplateData]="templateData"
              [correspondenceDataObj]="correspondenceDataObj"
              [candidateEmails]="candidateEmails"
              [candidateApplicationIds]="candidateApplicationIds"
              [selectedCandidate]="selectedCandidate"
            ></activity-correspondence>
          </div>
          <div>
            <app-attachment
              (fileOutput)="receiveFileOutput($event)"
              [toggleBtn]="toggleBtn"
              [allowedTypes]="allowedTypes"
              [uploadType]="multiple"
              [editId]="editId"
              activityModuleFlag="true"
            ></app-attachment>
          </div>

          <div class="row" *ngIf="!ifCoupled">
            <div class="row nomarLR padTB16">
              <div class="col-6">
                <button
                  mat-raised-button
                  class="primary-btn btnfullWdth"
                  name="coupledsendbutton"
                  [disabled]="f1.invalid"
                  (click)="send()"
                >
                  Send
                </button>
              </div>
            </div>
          </div>
        </form>
      </mat-card-content>
      <mat-card-actions class="collapseAction">
        <div>
          <mat-card-actions class="collapseAction">
            <div>
              <a
                href="javascript:void(0)"
                name="collapseAction"
                *ngIf="isCollapsed"
                class="icon x-24"
                (click)="showMoreLess()"
              >
                <img src="../assets/images/icons/orange_icons/icon-collapse-arrow.png" alt="icon-collapse" />
              </a>
              <a
                href="javascript:void(0)"
                name="collapseAction"
                *ngIf="!isCollapsed"
                class="icon x-24"
                (click)="showMoreLess()"
              >
                <img src="../assets/images/icons/orange_icons/icon-expand-arrow.png" alt="icon-expand" />
              </a>
            </div>
          </mat-card-actions>
        </div>
      </mat-card-actions>
    </mat-card>
  </div>
</div>
